<template>
    <div class="font-serif antialiased leading-tight p-0 xs:-mr-5 w-full overflow">
        <div class="bg-main-black mx-auto text-grey-lightest p-6 text-center font-semibold text-3xl">
            <div class="flex justify-center items-center w-full text-center">
                <div>
                    <img src="./assets/logo.svg" alt="Luyao Logo" class="h-16 rounded mr-6" />
                </div>
                <a href="/" class="no-underline text-white">Luyao</a>
            </div>
        </div>
        <div class="p-12">
            <h1>Privacy Policy</h1>
            <p class="my-2">Last updated: November 16, 2023</p>
            <p class="mt-2 mt-10">
                At <span class="font-bold">Luyao</span>, we prioritize the
                privacy and security of our users. We want to assure you that we
                do not collect any personal data or information from our users
                as our app operates completely offline without any server
                involvement.
            </p>
            <p class="my-6">
                As an offline app, we do not store, track, or transmit any user
                data, ensuring that your privacy remains intact. We understand
                the importance of maintaining the confidentiality of your
                information, and we take every measure to ensure that your data
                remains secure within your device.
            </p>
            <p class="my-6">
                Rest assured that your personal privacy is our utmost priority,
                and we are committed to providing you with a trusted and secure
                health tracking experience. If you have any concerns or
                questions regarding our privacy policy, please don't hesitate to
                contact us.
            </p>
            <p class="my-3">At the same time, for your convenience, users on different platforms will utilize distinct
                methods to store
                your offline data. Even if you change your phone, your data remains accessible.</p>
            <p class="my-3">This is not mandatory. By default, data is only stored on your mobile device. When you enable synchronization
                within the app, the scenarios on different platforms are as follows:</p>
            <p class="mt-10 text-lg font-bold">
                For Android Users
            </p>
            <p class="mt-3 mb-1 font-bold text-sm">Data Collection and Use:</p>
            <p>Our application stores user data through Google Drive.</p>
            <p class="mt-4 mb-1 font-bold text-sm">Google Drive Access Permissions:</p>
            <p>To provide our service, we need to obtain your Google Drive access permissions. We will only access and use
                data explicitly authorized by you, and we will not exceed the scope of authorization.</p>
            <p class="mt-4 mb-1 font-bold text-sm">Data Storage:</p>
            <p>User data is stored on Google Drive, and we have implemented appropriate security measures to protect the
                confidentiality and integrity of this data. We are committed to safeguarding user privacy and take measures
                to prevent unauthorized access.</p>
            <p class="mt-4 mb-1 font-bold text-sm">Data Sharing:</p>
            <p>Our application will not share your personal data stored on Google Drive with third parties.</p>
            <p class="mt-4 mb-1 font-bold text-sm">User Control:</p>
            <p>You can access, modify, or delete your data stored on Google Drive at any time.</p>


            <p class="mt-10 text-lg font-bold">
                For iOS Users
            </p>
            <p class="mt-3 mb-1 font-bold text-sm">Data Collection and Use:</p>
            <p>
                We save app's data is stored securely on iCloud to ensure accessibility across your iOS devices.
            </p>
            <p class="mt-4 mb-1 font-bold text-sm">iCloud Access Permissions:</p>
            <p>
                To enable iCloud functionality, our application requests and utilizes iCloud access permissions.
                We strictly adhere to the permissions granted by the user and do not access data beyond the authorized
                scope.
            </p>
            <p class="mt-4 mb-1 font-bold text-sm">Data Storage on iCloud:</p>
            <p>
                User data is securely stored on iCloud, leveraging iCloud's robust security measures to protect the
                confidentiality and integrity of the data.
            </p>
            <p class="mt-4 mb-1 font-bold text-sm">Data Sharing:</p>
            <p>User data stored on iCloud is not shared with third parties. We prioritize user privacy and confidentiality.
            </p>
            <p class="mt-4 mb-1 font-bold text-sm">User Control:</p>
            <p>Users have control over their data stored on iCloud. They can manage and delete their data through iOS
                settings.</p>
            <p class="mt-10">
                Please note that this privacy policy applies solely to
                <span class="font-bold">Luyao</span> and does not cover any
                third-party apps or services that you may access through our
                app.
            </p>
            <p class="mt-6">
                Thank you for choosing <span class="font-bold">Luyao</span> to
                manage your health, and we appreciate your trust in our
                commitment to your privacy.
            </p>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            messages: null,
        };
    },
};
</script>

<style>
@tailwind preflight;
@tailwind components;
@tailwind utilities;
</style>
